import React, { useContext, useState, useEffect } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import Cookies from "js-cookie";
import { Alert } from "../Alert";
import { ModalComp } from "../ModalComp";
import { useTranslation } from "react-i18next";
import { AutomationZones } from "./AutomationZones";
import { automationAddWidget } from "../../api";

const AutomationAdd = ({
  titleEdit,
  iconEdit,
  uid,
  submit,
  setOpenAddAutomationModal,
  closeModal,
  props,
  scenarioCommandEdit,
  setScenarioCommandEdit,
}) => {
  const [idd, setIdd] = useState("");
  const token = Cookies.get("token");
  const [title, setTitle] = useState(titleEdit);
  const [widgetIndex, setWidgetIndex] = useState("");
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });
  const { t } = useTranslation();
  const [automationCommand, setAutomationCommand] = useState([]);
  const [automationCommandCopy, setAutomationCommandCopy] =
    useState(automationCommand);
  const toggleAlert = () => {
    setShowAlert((prevState) => ({
      ...prevState,
      show: false,
      question: false,
    }));
  };
  const handleTitle = (e) => {
    setTitle(e.target.value);
    console.log(e.target.value);
  };
  const icons = [
    "icon-slepp",
    "icon-muic",
    "icon-in",
    "icon-out",
    "icon-sun",
    "icon-tvv",
  ];
  const [icon, setIcon] = useState(iconEdit || "icon-muic");
  const handleIcon = (i) => {
    setIcon(i);
    console.log(icon);
  };
  const [isOpen, setIsOpen] = useState(false);
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  const widgetClicked = (value, index) => {
    setWidgetIndex(index);
  };
  const handleClose = (i) => {
    const cllose = automationCommand.filter(
      (index) => index.caption.caption !== i
    );
    setAutomationCommand(cllose);
  };
  //add automation
  const handleAddAutomation = () => {
    if (!title) {
      setShowAlert((prevState) => ({
        ...prevState,
        show: true,
        message: "لطفا یک نام برای اتوماسیون خود انتخاب نمایید",
        type: "Warning",
        question: false,
      }));
      setTimeout(() => {
        setShowAlert((prevState) => ({
          ...prevState,
          show: false,
        }));
      }, 5000);
    } else if (automationCommandCopy.length > 0) {
      const serialIndex = {};
      for (let i = 0; i < automationCommandCopy.length; i++) {
        const currentSerial = automationCommandCopy[i].serial.serial;
        if (serialIndex[currentSerial] !== undefined) {
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t("عدم ثبت به علت ورود رویداد های تکراری"),
            type: "Error",
            question: false,
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              show: false,
            }));
          }, 5000);
        } else {
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t("آیا اتوماسیون ") + t(`${title}`) + t(" ثبت گردد؟"),
            type: "Warning",
            question: true,
            request: "addAutomationNew",
          }));

          // setSelectWidget(!selectWidget);
          setAutomationCommandCopy([]);
          serialIndex[currentSerial] = i;
        }
      }
    } else {
      setShowAlert((prevState) => ({
        show: true,
        message: t("ابتدا میبایست رویداد های اتوماسیون را وارد نمایید"),
        type: "Error",
        question: false,
      }));
      setTimeout(() => {
        setShowAlert((prevState) => ({
          show: false,
        }));
      }, 5000);
    }
  };
  //end//
  //AddEvents//
  const [openAutomationZoneModal, setOpenAutomationZoneModal] = useState(false);

  const toggleAutomationZone = () => {
    setOpenAutomationZoneModal(!openAutomationZoneModal);
  };
  const handleShowEvents = () => {
    if (title) {
      setOpenAutomationZoneModal(true);
    } else {
      setShowAlert((prevState) => ({
        ...prevState,
        show: true,
        message: t(".لطفا یک نام برای اتوماسیون خود انتخاب نمایید"),
        type: "Warning",
      }));
      setTimeout(() => {
        setShowAlert((prevState) => ({
          ...prevState,
          show: false,
        }));
      }, 5000);
    }
    // setSelectWidget(!selectWidget);
  };

  useEffect(() => {
    setAutomationCommandCopy(automationCommand);
    console.log(automationCommand);
    automationCommand.map((item) => {
      var data = new FormData();
      data.append("serial", item.serial.serial);
      data.append("widget", item.id.id);
      data.append("command", item.command.command);
      data.append("automation_id", "f86dc791-cf81-4bad-85db-a6a83f08174a");
      console.log("heeeeeeeeeeee", item);
      automationAddWidget(data, token)
        .then((result) => console.log("result"))
        .catch((error) => {
          if (error.response.status === 403) {
            // Cookies.remove("token");
            // props.history.push("/login");
            console.log("error");
          }
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
            type: "Error",
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              ...prevState,
              show: false,
            }));
          }, 2000);
        });
    });
  }, [automationCommand]);

  useEffect(() => {
    console.log(automationCommand);
    automationCommand.map((item) => {
      var data = new FormData();
      data.append("serial", item.serial.serial);
      data.append("widget", item.caption.caotion);
      data.append("command", item.command.command);
      data.append("automation_id", "abbc6a19-bcd6-4ada-8b33-b500711daf61");
      automationAddWidget(data, token)
        .then((result) => console.log("result"))
        .catch((error) => {
          if (error.response.status === 403) {
            // Cookies.remove("token");
            // props.history.push("/login");
            console.log("error");
          }
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
            type: "Error",
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              ...prevState,
              show: false,
            }));
          }, 2000);
        });
    });
  }, [idd]);
  ////////////////////////////////////////////////////////

  return (
    <>
      <ModalComp
        modal={openAutomationZoneModal}
        toggle={toggleAutomationZone}
        component={
          <AutomationZones
            title={title}
            icon={icon}
            setAutomationCommand={setAutomationCommand}
            // scenarioId={scenarioId}
          />
        }
      />

      <div className="m-auto d-flex justify-content-between align-items-center py-4 px-3">
        <div className="text-right">
          <p className="m-0 fn12">
            نام اتوماسیون و آیکون دلخواه خود را انتخاب نمایید
          </p>
        </div>
      </div>
      <div className=" addScenarioCard bg-white  mb-3 mt-3 d-flex text-right justify-content-between align-items-center px-3 py-2">
        <input
          className="inputStyle"
          type="text"
          placeholder="اضافه کردن اتوماسیون..."
          onChange={handleTitle}
          value={title}
        ></input>
        <Dropdown isOpen={isOpen} toggle={toggleDropdown}>
          <DropdownToggle
            className="addScenarioIcon border-0 text-center rounded-circle d-flex flex-column"
            style={{ backgroundColor: "#007bff", color: "#fff" }}
          >
            {icon && (
              <i
                className={icon}
                style={{ color: "#fff", margin: "auto", fontSize: "20px" }}
              />
            )}
          </DropdownToggle>
          <DropdownMenu>
            {icons.map((icon, index) => (
              <DropdownItem key={icon} onClick={() => handleIcon(icon)}>
                <i key={index} className={icon} />
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>
      </div>
      <div className="scroll ">
        {automationCommand.length ? (
          <div>
            <small> {t("رویدادهای انتخاب شده:")}</small>
          </div>
        ) : (
          ""
        )}
        <div>
          {automationCommand?.map((item, index) => {
            console.log(item);
            let active = widgetIndex === index ? "selectZonesActive" : "";
            const widgetId = item;
            // console.log(widgetId);
            return (
              <div>
                <div
                  onClick={() => widgetClicked(item, index)}
                  key={index}
                  className={`selectWidget 
           text-center py-2 my-2 cursor ${active}`}
                >
                  <div className="d-flex border-bottom-4 justify-content-between px-2">
                    <label className="  ">
                      {item.caption.caption}
                      {" : "}
                      {item.command.command === "10" ? t("روشن") : t("خاموش")}
                    </label>
                    <button
                      className="btn-close "
                      onClick={() => {
                        handleClose(item.caption.caption);
                      }}
                    ></button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "60vh" }}
      >
        <div
          className="mx-3 d-flex justify-content-center align-items-center flex-column text-center"
          onClick={handleShowEvents}
        >
          <span className="profileAddUser bg-white d-block cursor">+</span>
          <small className="fn12 mt-1">{t("رویداد")}</small>
        </div>

        <div
          className="mx-3 d-flex justify-content-center align-items-center flex-column text-center"
          onClick={handleAddAutomation}
        >
          <span className="profileAddUser bg-white d-block icon-ok cursor"></span>
          <small className="fn12 mt-1">{t("ثبت")}</small>
        </div>
      </div>
      {showAlert.show && (
        <Alert
          message={showAlert.message}
          type={showAlert.type}
          title={title}
          icon={icon}
          question={showAlert.question}
          request={showAlert.request}
          toggleAlert={toggleAlert}
          setOpenAddAutomationModal={setOpenAddAutomationModal}
          setIdd={setIdd}
        />
      )}
    </>
  );
};
export { AutomationAdd };
